import {
  Checkbox, Form, Input, InputNumber, Select,
} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import DraggableModal from '../draggableModal/DraggableModal';
import './ImpactForm.css';
import styles from './styles.module.scss';


const { TextArea } = Input;
const { Option } = Select;

function ImpactForm({
  visible, onOk, onCancel,
}) {
  const [form] = Form.useForm();
  const modalTitle = <div className="handle">Register Form</div>;

  const validateInput = async (_, value) => {
    const pattern = /^(?!\d*[.,]{2})\d*([.,])?\d*$/;
    if (!pattern.test(value)) {
      return Promise.reject(new Error('Invalid number'));
    }
    return Promise.resolve();
  };

  return (
    <DraggableModal
      title={modalTitle}
      visible={visible}
      onOk={() => onOk(form.getFieldsValue())}
      onCancel={onCancel}
      okText="Submit"
      cancelText="Cancel"
      className="impactForm"
      content={(
        <Form
          form={form}
          layout="vertical"
        >
          <div className={styles.impactFormItem}>
            <span>Plant</span>
            <Form.Item name="plant">
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div className={styles.impactFormItem}>
            <span>Material</span>
            <Form.Item name="material">
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          </div>

          {/*  I don't trust this implementation, will return
          <Form.Item rules={[{ validator: validateInput }]}
          label="Impact (NOK)" name="impact"> */}
          <div className={styles.impactFormItem}>
            <span>Impact (NOK)</span>
            <Form.Item name="impact">
              <Input style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div className={styles.impactFormItem}>
            <span>Impact Type</span>
            <Form.Item name="impactType">
              <Select style={{ width: '100%' }}>
                <Option value="Savings">Savings</Option>
                <Option value="Investment">Investment</Option>
              </Select>
            </Form.Item>
          </div>
          <div className={styles.impactFormItem}>
            <span>Notes</span>
            <Form.Item name="notes">
              <TextArea style={{ width: '100%' }} />
            </Form.Item>
          </div>
          <div className={styles.impactFormItem}>
            <span>Overstock</span>
            <Form.Item
              name="overstock"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </div>
        </Form>
      )}
    />
  );
}

export default ImpactForm;

ImpactForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
